import { ALL_RANKING_PROPERTIES } from '../../types/rankingsTypes';
import { uuid } from '../../utils/utils';
import { getOutboundMessage } from './outboundUtils';
export function createKeepAliveOutbound() {
    return getOutboundMessage({
        _type: 'keepalive',
        parts: [{ name: 'uuid', stringValue: uuid() }] // the UUID is meaningless but it creates a unique message
    });
}
export function createFriendsListOpenOutbound() {
    return getOutboundMessage({
        _type: 'friends_open'
    });
}
export function createFriendsListClosedOutbound() {
    return getOutboundMessage({
        _type: 'friends_close'
    });
}
export function createRebuyOutbound() {
    return getOutboundMessage({
        _type: 'rebuy'
    });
}
export function createGetPlayerInfoOutbound(playerId) {
    return getOutboundMessage({
        _type: 'get_player_info',
        parts: [{ name: 'playerId', numberValue: playerId }]
    });
}
export function createGetSelfInfoOutbound() {
    return getOutboundMessage({
        _type: 'get_self_info'
    });
}
export function createChangePasswordOutbound(currentPassword, newPassword) {
    return getOutboundMessage({
        _type: 'change_password',
        parts: [
            { name: 'currentPassword', stringValue: currentPassword, needsEncoding: true },
            { name: 'newPassword', stringValue: newPassword, needsEncoding: true },
            { name: 'newPasswordConfirmation', stringValue: newPassword, needsEncoding: true }
        ]
    });
}
export function createResetPasswordOutbound({ newPassword, uuid, playerId }) {
    return getOutboundMessage({
        _type: 'reset_password',
        parts: [
            { name: 'newPassword', stringValue: newPassword, needsEncoding: true },
            { name: 'uuid', stringValue: uuid, needsEncoding: true },
            { name: 'playerId', numberValue: playerId }
        ]
    });
}
export function createChangeEmailOutbound(newEmail, currentPassword) {
    return getOutboundMessage({
        _type: 'change_email',
        parts: [
            { name: 'newEmail', stringValue: newEmail, needsEncoding: true },
            { name: 'newEmailConfirmation', stringValue: newEmail, needsEncoding: true },
            { name: 'currentPassword', stringValue: currentPassword, needsEncoding: true }
        ]
    });
}
export function createRequestJacksToChipsOptionsOutbound() {
    return getOutboundMessage({
        _type: 'chips_win'
    });
}
export function createConvertJacksToChipsOutbound(jacksToChipsOption) {
    return getOutboundMessage({
        _type: 'convert_jacks',
        parts: [
            { name: 'jacksToChipsOptionId', numberValue: jacksToChipsOption.jacksToChipsOptionId },
            { name: 'numChips', numberValue: jacksToChipsOption.numChips },
            { name: 'numJacks', numberValue: jacksToChipsOption.numJacks }
        ]
    });
}
export function createConfirmIncomeEventOutbound(incomeEventId) {
    return getOutboundMessage({
        _type: 'income_win_read',
        parts: [{ name: 'incomeEventId', numberValue: incomeEventId }]
    });
}
export function createActivatePowerPlayerOutbound(productCode) {
    return getOutboundMessage({
        _type: 'jacks_activate_pp',
        parts: [{ name: 'productCode', stringValue: productCode }]
    });
}
export function createRequestPowerPlayerWindowOutbound() {
    return getOutboundMessage({
        _type: 'power_player_win'
    });
}
export function createGiveJacksOutbound(toUsername, numJacksToGiveOrString, isConfirmed) {
    return getOutboundMessage({
        _type: 'jacks_give',
        parts: [
            { name: 'isConfirmed', booleanValue: isConfirmed },
            { name: 'toUsername', stringValue: toUsername, needsEncoding: true },
            { name: 'numJacksToGiveStr', stringValue: `${numJacksToGiveOrString}`, needsEncoding: true } // could be the string 'all'
        ]
    });
}
export function createCheckGiveChipsOutbound(toPlayerId) {
    return getOutboundMessage({
        _type: 'check_give_chips',
        parts: [{ name: 'toPlayerId', numberValue: toPlayerId }]
    });
}
export function createGiveChipsOutbound(toPlayerId, numChips) {
    return getOutboundMessage({
        _type: 'give_chips',
        parts: [
            { name: 'toPlayerId', numberValue: toPlayerId },
            { name: 'numChips', numberValue: numChips }
        ]
    });
}
export function createChangeSettingOutbound(settingType) {
    return getOutboundMessage({
        _type: 'genchat',
        // TODO: Create an outbound type (and handler on server) specific to toggling/cycling through a setting's options:
        parts: [{ name: 'genChatCommand', stringValue: `/option_inc ${settingType}` }]
    });
}
export function createSuperAdminRequestConfigSettingsOutbound() {
    return getOutboundMessage({
        _type: 'config_settings'
    });
}
export function createSuperAdminListModestPlayersOutbound() {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: '/list-modest-players' }]
    });
}
export function createShowRakeTotalsOutbound() {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: '/show-rake-totals' }]
    });
}
export function createShowTestEmailLogOutbound() {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: '/show-test-email-log' }]
    });
}
export function createFindPlayerOutbound(username) {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: `/find ${username}` }]
    });
}
export function createFindPlayerByIdOutbound(playerId) {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: `/find_id ${playerId}` }]
    });
}
export function createMutePlayerOutbound(username, numMinutes) {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: `/mute ${username} ${numMinutes}` }]
    });
}
export function createUnmutePlayerOutbound(username) {
    return getOutboundMessage({
        _type: 'genchat',
        parts: [{ name: 'genChatCommand', stringValue: `/unmute ${username}` }]
    });
}
export function createGetAccountInfoOutbound() {
    return getOutboundMessage({
        _type: 'get_account_info'
    });
}
export function createBlockChatOutbound(fromPlayerId, isBlocking) {
    return getOutboundMessage({
        _type: 'block_chat',
        parts: [
            { name: 'fromPlayerId', numberValue: fromPlayerId },
            { name: 'isBlocking', booleanValue: isBlocking }
        ]
    });
}
export function createBlockMessagesOutbound(fromPlayerId, isBlocking) {
    return getOutboundMessage({
        _type: 'block_pms',
        parts: [
            { name: 'fromPlayerId', numberValue: fromPlayerId },
            { name: 'isBlocking', booleanValue: isBlocking }
        ]
    });
}
export function createRenamePlayerAdminActionOutbound(playerId, newUsername) {
    return getOutboundMessage({
        _type: 'rename_player',
        parts: [
            { name: 'playerId', numberValue: playerId },
            { name: 'newUsername', stringValue: newUsername }
        ]
    });
}
export function createInfiniteLoopAdminActionOutbound(playerId) {
    return getOutboundMessage({
        _type: 'il',
        parts: [{ name: 'playerId', numberValue: playerId }]
    });
}
export function createGetRankingListOutbound(rankingType) {
    return getOutboundMessage({
        _type: 'get_ranking_list',
        parts: [
            { name: 'rankingServerName', stringValue: ALL_RANKING_PROPERTIES[rankingType].serverName, needsEncoding: true }
        ]
    });
}
export function createGetRecentTourneyWinnersOutbound() {
    return getOutboundMessage({ _type: 'get_recent_tourney_winners' });
}
export function createRequestPlayerDebugInfoOutbound(playerId) {
    return getOutboundMessage({
        _type: 'request_player_debug_info',
        parts: [{ name: 'playerId', numberValue: playerId }]
    });
}
export function createRequestedDebugInfoOutbound(requestingAdminPlayerId, debugInfo) {
    const debugInfoString = `{${Object.entries(debugInfo)
        .map(([key, value]) => `{${encodeURIComponent(key)},${encodeURIComponent(value)}}`)
        .join(',')}}`;
    return getOutboundMessage({
        _type: 'requested_debug_info',
        parts: [
            { name: 'requestingAdminPlayerId', numberValue: requestingAdminPlayerId },
            { name: 'encodedDebugInfoString', stringValue: debugInfoString, needsEncoding: true }
        ]
    });
}
export function createGetNewestPlayersListOutbound() {
    return getOutboundMessage({ _type: 'get_newest_players_list' });
}
export function createGetAdminNewestPlayersListOutbound() {
    return getOutboundMessage({ _type: 'get_admin_newest_players_list' });
}
export function createGetRecentAdminActionsOutbound() {
    return getOutboundMessage({ _type: 'get_recent_admin_actions' });
}
export function createSetChipsRakeTotalForTestingOutbound(newChipsRakeTotal) {
    return getOutboundMessage({
        _type: 'set_chips_rake_total_for_testing',
        parts: [{ name: 'newChipsRakeTotal', numberValue: newChipsRakeTotal }]
    });
}
export function createRecordStatOutbound(statName, statValue = '') {
    return getOutboundMessage({
        _type: 'record_stat',
        parts: [
            { name: 'statName', stringValue: statName },
            { name: 'statValue', stringValue: statValue, needsEncoding: true }
        ]
    });
}
export function createGetUpcomingTourneysOutbound() {
    return getOutboundMessage({ _type: 'get_upcoming_tourneys' });
}
export function createGetTourneyDetailsOutbound(autoMttId) {
    return getOutboundMessage({ _type: 'get_tourney_details', parts: [{ name: 'autoMttId', numberValue: autoMttId }] });
}
export function createShowBlockedPlayersOutbound(playerId) {
    const parts = playerId !== undefined ? [{ name: 'playerId', numberValue: playerId }] : undefined;
    return getOutboundMessage({ _type: 'show_blocked_players', parts });
}
export function createGetFreeDailyBonusOutbound() {
    return getOutboundMessage({ _type: 'get_free_daily_bonus' });
}
export function createGetSharedDeviceIdsOutbound() {
    return getOutboundMessage({ _type: 'get_shared_device_ids' });
}
export function createSendContactUsMessageOutbound(message) {
    return `send_contact_us_message:${JSON.stringify({ message })}`;
}
